import {
  DEFAULT_DATA_URL,
  processData,
} from '../../pages/AudioPlayer/utils/audioUtils';
import { dmyToIso, hasDevanagari, once, pickForToday } from '../util';

// Same sources the audio player uses: remote catalogue, then bundled copy.
export const loadCatalogue = once(async () => {
  for (const url of [DEFAULT_DATA_URL, '/audio_data.json']) {
    try {
      const res = await fetch(url);
      if (res.ok) return processData(await res.json());
    } catch (e) {
      // try the next source
    }
  }
  throw new Error('audio catalogue unavailable');
});

const audio = {
  id: 'audio',
  label: 'Audio',
  async getItems({ now }) {
    const items = (await loadCatalogue()).map((it) => ({
      ...it,
      isoDate: dmyToIso(it.date),
    }));
    return pickForToday(items, 6, {
      now,
      key: (it) => it.id,
      date: (it) => it.isoDate,
    }).map((it) => ({
      id: `audio:${it.id}`,
      type: 'audio',
      kicker: it.number ? `Listen · #${it.number}` : 'Listen',
      title: it.title,
      summary: [it.date, it.place].filter(Boolean).join(' · '),
      date: it.isoDate,
      lang: hasDevanagari(it.title) ? 'hi' : 'en',
      link: `/listen?item=${encodeURIComponent(it.id)}`,
      media: { thumbnail: it.thumbnail, duration: it.duration },
    }));
  },
};

export default audio;
